<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="app-main-content bill-payment">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;">
        <el-tab-pane :label="$t('Payment.all')" name="all" :lazy="true">
          <tab-bill-payment-bpm v-if="allIsShow" ref="billPaymentWorkflow5" :application-status="0" :is-append-query="true" :show-wht="true" />
        </el-tab-pane>
        <el-tab-pane :label="$t('Payment.notSubmitted')" name="notSubmitted">
          <tab-bill-payment-bpm v-if="notSubmittedIsShow" :application-status="1" :is-append-query="true" :show-wht="true" />
        </el-tab-pane>
        <el-tab-pane :label="$t('CargoMsg.Cargo_AwaitApproval_SR')" name="awaitBusinessApproval" :lazy="true">
          <tab-bill-payment-bpm v-if="awaitBusinessApprovalIsShow" :application-status="2" :is-append-query="true" :show-wht="true" />
        </el-tab-pane>
        <el-tab-pane :label="$t('Payment.approval')" name="approval" :lazy="true">
          <tab-bill-payment-bpm v-if="approvalIsShow" :application-status="3" :is-append-query="true" :show-wht="true" />
        </el-tab-pane>
        <el-tab-pane :label="$t('Payment.unpaid')" name="unpaid" :lazy="true">
          <tab-bill-payment-bpm v-if="unpaidIsShow" :application-status="4" :is-append-query="true" :show-wht="true" />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import TabBillPaymentBpm from '@/views/cargo/v0/Clearing/components/BillPayment/tabBillPaymentBpm'

export default {
  name: 'BillPaymentBpm',
  components: { TabBillPaymentBpm },
  data() {
    return {
      activeTabName: 'notSubmitted',
      notSubmittedIsShowed: false,
      awaitBusinessApprovalIsShowed: false,
      awaitFinancialApprovalIsShowed: false,
      approvalIsShowed: false,
      unpaidIsShowed: false,
      allIsShowed: false
    }
  },
  computed: {
    notSubmittedIsShow() {
      if (this.activeTabName === 'notSubmitted' && !this.notSubmittedIsShowed) {
        this.notSubmittedIsShowed = true
      }
      return this.notSubmittedIsShowed
    },
    awaitBusinessApprovalIsShow() {
      if (this.activeTabName === 'awaitBusinessApproval' && !this.awaitBusinessApprovalIsShowed) {
        this.awaitBusinessApprovalIsShowed = true
      }
      return this.awaitBusinessApprovalIsShowed
    },
    approvalIsShow() {
      if (this.activeTabName === 'approval' && !this.approvalIsShowed) {
        this.approvalIsShowed = true
      }
      return this.approvalIsShowed
    },
    unpaidIsShow() {
      if (this.activeTabName === 'unpaid' && !this.unpaidIsShowed) {
        this.unpaidIsShowed = true
      }
      return this.unpaidIsShowed
    },
    allIsShow() {
      if (this.activeTabName === 'all' && !this.allIsShowed) {
        this.allIsShowed = true
      }
      return this.allIsShowed
    }
  },
  created() {
  },
  activated() {
    if (this.$route.params.applicationStatus && this.$route.params.billPaymentUuid) {
      if (this.activeTabName !== 'all') {
        this.activeTabName = 'all'
      }
      this.$nextTick(() => {
        this.$refs.billPaymentWorkflow5.fetchDataByKey(this.$route.params.billPaymentUuid)
      })
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
